// ─── Footer: Centered Luxe ────────────────────────────────────
// Centered closing message with gold accent border-top.
// Minimal, elegant dark-theme footer.

import React from 'react';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';

export default function FooterCenteredLuxe({ section, data, theme, rsvpRef }) {
  const anim = section.animation || {};

  const scrollToRSVP = () => rsvpRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  return (
    <footer className="px-6 py-20 sm:py-28" data-testid="footer-section">
      <AnimatedSection preset={anim.section || 'fade-in'}>
        <div
          className="mx-auto max-w-3xl border-t pt-10 text-center"
          style={{ borderColor: theme.accentSoft }}
        >
          <p
            className="text-3xl sm:text-5xl leading-tight"
            style={{ fontFamily: theme.headingFont, color: theme.textPrimary }}
          >
            {data.closingMessage || 'We look forward to celebrating with you.'}
          </p>
          <p
            className="mt-5 text-[11px] uppercase tracking-[0.2em]"
            style={{ color: theme.accent, fontFamily: theme.eyebrowFont }}
          >
            {data.names || ''}
          </p>
          <button
            onClick={scrollToRSVP}
            className="mt-10 px-10 py-3.5 rounded-full text-xs font-medium tracking-widest uppercase transition-all hover:opacity-90"
            style={{ background: theme.buttonBg, color: theme.buttonText, fontFamily: theme.eyebrowFont }}
            data-testid="footer-rsvp-cta"
          >
            RSVP Now
          </button>
        </div>
      </AnimatedSection>
    </footer>
  );
}
